import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { GeneralSettingMutationKeys } from '../../../keys'
import {
	UpdateGeneralSettingRequest,
	UpdateGeneralSettingResponse,
} from '../../../type'
import { updateGeneralSetting } from '../../services'

interface UseMutationUpdateGeneralSettingProps {
	payload: UpdateGeneralSettingRequest
}

export default function useMutationUpdateGeneralSetting(
	props?: UseBaseMutationOptions<
		UpdateGeneralSettingResponse,
		UseMutationUpdateGeneralSettingProps
	>,
) {
	return useMutation({
		mutationKey: [GeneralSettingMutationKeys.UpdateGeneralSetting],
		mutationFn: (params) => updateGeneralSetting(params.payload),
		...props,
	})
}
